/**
 * Canonical source of truth for album type classification.
 * Derived from Discogs media features at ETL time.
 */

import { z } from "zod";

export const ALBUM_TYPES = ["album", "compilation", "single_ep", "live", "video", "other"] as const;
export const albumTypeEnum = z.enum(ALBUM_TYPES);
export type AlbumType = z.infer<typeof albumTypeEnum>;
